import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  HomeIcon,
  InboxIcon,
  HeartIcon as HeartOutline,
  CogIcon,
  ArrowLeftOnRectangleIcon,
  Bars3Icon,
  XMarkIcon,
  UserCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  DocumentIcon,
  UserGroupIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
import logoes from "../assets/Logo.png";
import NavPointsIcon from "../assets/Icons/points-icon.svg";
import Footer from "./footer";
import RightArrowCard from "../assets/Icons/right-arrow.svg";
import FavouritesIconFilledWhite from "../assets/Icons/favourite-icon-outline.png";
import FavouritesIconFilledRed from "../assets/Icons/favourite-icon-filled.svg";
import AsideFavouriteIconOutlineDark from "../assets/Icons/aside-favourite-icon-dark.svg";
import AsideFavouriteIconOutlineWhite from "../assets/Icons/aside-favourite-icon-white.svg";
import Navbar from "./navbar";
import { debounce } from "lodash";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { FiSettings } from "react-icons/fi";

// Section Component
const Section = ({ title, isOpen, toggle, children }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={toggle}
      className="w-full flex justify-between items-center py-2 text-left text-lg font-medium text-[#676666]"
    >
      <span>{title}</span>
      <ChevronDownIcon
        className={`h-5 w-5 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
      />
    </button>
    {isOpen && <div className="p-4">{children}</div>}
  </div>
);

// DetailItem Component
const DetailItem = ({ label, value }) => (
  <div className="flex justify-between py-1">
    <span className="text-gray-600">{label}:</span>
    <span className="text-gray-800">{value || "N/A"}</span>
  </div>
);

const Dashboard = () => {
  const { t, i18n } = useTranslation();
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [favoriteProfiles, setFavoriteProfiles] = useState([]);
  const [preferenceProfiles, setPreferenceProfiles] = useState([]);
  const [locationPreferenceProfiles, setLocationPreferenceProfiles] = useState(
    [],
  );
  
  const [loading, setLoading] = useState({
    default: true,
    favorites: true,
    preferences: true,
    locationpreference: true,
  });
  // Inside Dashboard component, add these state variables:
  const [searchTerm, setSearchTerm] = useState("");
  const [ageFilter, setAgeFilter] = useState("");
  const [casteFilter, setCasteFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [sort, setSortProfile] = useState("");
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [error, setError] = useState(null);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const dropdownRefLanguage = useRef(null);
  const dropdownRefProfile = useRef(null);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [isRechargePointsFormOpen, setIsRechargePointsFormOpen] =
    useState(false);
  const [previewDocument, setPreviewDocument] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [openSections, setOpenSections] = useState({
    personal: true,
    family: true,
    horoscope: true,
    preferences: true,
    documents: true,
  });
  const [showReportDropdown, setShowReportDropdown] = useState(null);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportReason, setReportReason] = useState("");
  const [reportingProfileId, setReportingProfileId] = useState("");
  const [ShowPopupRechargePoints, setShowPopupRechargePoints] = useState(false);
  const [isHeartsAnimating, setIsHeartsAnimating] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const newProfilesRef = useRef();
  const preferencesRef = useRef();
  const locationRef = useRef();
  const favoritesRef = useRef();
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [profileToView, setProfileToView] = useState(null);
  const [viewedProfiles, setViewedProfiles] = useState([]);

  const openViewAllModal = (profiles, title) => {
    sessionStorage.setItem("viewAllProfiles", JSON.stringify(profiles));
    sessionStorage.setItem("viewAllTitle", title);
    navigate("/view-all-profiles");
  };

  
    
useEffect(() => {
  const fetchViewedProfiles = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch('https://backend.newbrindha.com/matrimony/viewed-profiles', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (response.ok) {
        const data = await response.json();
        setViewedProfiles(data.viewed_profiles || []);
      }
    } catch (error) {
      console.error('Error fetching viewed profiles:', error);
    }
  };
  
  fetchViewedProfiles();
}, []);


const handleSpendPoints = (profile) => {
  if (viewedProfiles.includes(profile.matrimony_id)) {
    
    setSelectedProfile(profile);
    return;
  }
  
  
  setProfileToView(profile);
  setShowConfirmPopup(true);
};


const confirmSpendPoints = async () => {
  const token = localStorage.getItem('authToken');
  try {
    
    const response = await fetch('https://backend.newbrindha.com/wallet/spend', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        spend_requests: [{ profile_matrimony_id: profileToView.matrimony_id, points: 500 }],
      }),
    });

    const data = await response.json();
    if (response.ok) {
      if (data.token) localStorage.setItem('authToken', data.token);
      
      
      const markViewedResponse = await fetch('https://backend.newbrindha.com/matrimony/mark-viewed', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ profile_matrimony_ids: [profileToView.matrimony_id] }),
      });
      
      if (markViewedResponse.ok) {
        setViewedProfiles(prev => [...prev, profileToView.matrimony_id]);
        setSelectedProfile(profileToView);
        
       
        const balanceResponse = await fetch('https://backend.newbrindha.com/wallet/balance', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        
        if (balanceResponse.ok) {
          const balanceData = await balanceResponse.json();
          window.dispatchEvent(new CustomEvent('updatePoints', { detail: balanceData.points_balance }));
        }
        
        toast.success(t('pointsSpentSuccess'));
      }
    } else {
      setShowPopupRechargePoints(true);
    }
  } catch (error) {
    console.error('Spend Points Error:', error.message);
    toast.error(t('pointsSpentError', { error: error.message }));
  } finally {
    setShowConfirmPopup(false);
    setProfileToView(null);
  }
};

  
  

  
 const handleLogout = () => {
  localStorage.removeItem('authToken');
  setViewedProfiles([]); // Changed from new Set() to []
  navigate('/login');
};

  



  const toggleFavourite = async (profile) => {
    try {
      const token = localStorage.getItem("authToken");
      const profileId = profile.matrimony_id;
      const isCurrentlyFavorited =
        favorites.includes(profileId) ||
        favoriteProfiles.some((p) => p.matrimony_id === profileId);
      const requestBody = {
        favorite_profile_ids: isCurrentlyFavorited ? [] : [profileId],
        unfavorite_profile_ids: isCurrentlyFavorited ? [profileId] : [],
      };

      const updatedFavorites = isCurrentlyFavorited
        ? favorites.filter((id) => id !== profileId)
        : [...favorites, profileId];
      setFavorites(updatedFavorites);
      //localStorage.setItem("favorites", JSON.stringify(updatedFavorites));

      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/favorite-profiles",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      if (!response.ok) throw new Error("Failed to update favorites");
      await fetchFavoriteProfiles();
    } catch (error) {
      console.error("Error updating favorites:", error);
      const savedFavorites = JSON.parse(
        localStorage.getItem("favorites") || "[]",
      );
      setFavorites(savedFavorites);
    }
  };

  const handleReportProfile = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/user/report",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            reported_matrimony_id: reportingProfileId,
            reason: reportReason,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to report profile");
      }

      const data = await response.json();
      toast.success(data.message || t("reportSuccess"));
      setShowReportModal(false);
      setReportReason("");
      setReportingProfileId("");
    } catch (error) {
      console.error("Error reporting profile:", error);
      toast.error(error.message || t("reportError"));
    }
  };

  const openReportModal = (profileId) => {
    setReportingProfileId(profileId);
    setShowReportModal(true);
    setShowReportDropdown(null);
  };

  const toggleReportDropdown = (profileId) => {
    setShowReportDropdown(showReportDropdown === profileId ? null : profileId);
  };

  useEffect(() => {
    const savedFavorites = localStorage.getItem("favorites");
    if (savedFavorites) {
      setFavorites(JSON.parse(savedFavorites));
    }
  }, []);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const photos = selectedProfile?.photos_base64
    ? Object.entries(selectedProfile.photos_base64).map(([key, value]) => ({
        id: key,
        base64: value,
      }))
    : [];

  const handlePreviewDocument = (documentBase64) => {
    setPreviewDocument(documentBase64);
  };

  const closePreview = () => {
    setPreviewDocument(null);
  };

  useEffect(() => {
    const handleClickOutsideLanguage = (event) => {
      if (
        dropdownRefLanguage.current &&
        !dropdownRefLanguage.current.contains(event.target)
      ) {
        setShowLanguageDropdown(false);
      }
    };

    const handleClickOutsideProfile = (event) => {
      if (
        dropdownRefProfile.current &&
        !dropdownRefProfile.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideLanguage);
    document.addEventListener("mousedown", handleClickOutsideProfile);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideLanguage);
      document.removeEventListener("mousedown", handleClickOutsideProfile);
    };
  }, []);

  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown((prev) => !prev);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    setShowLanguageDropdown(false);
  };

  const toggleProfileDropdown = () => {
    setShowProfileDropdown((prev) => !prev);
  };

  const fetchProfiles = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/login");
        return;
      }

      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/profiles",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/");
        return;
      }

      if (!response.ok) {
        throw new Error(t("fetchProfilesError"));
      }

      const data = await response.json();
      setProfiles({
        newProfiles: data["New Profiles"] || [],
        defaultProfiles: data["Default Profiles"] || [],
      });
      setLoading((prev) => ({ ...prev, default: false }));
    } catch (error) {
      setError(error.message);
      setProfiles({ newProfiles: [], defaultProfiles: [] });
      setLoading((prev) => ({ ...prev, default: false }));
    }
  };

  const fetchPreferenceProfiles = async () => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(
      "https://backend.newbrindha.com/matrimony/preference",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status === 401) {
      localStorage.removeItem("authToken");
      navigate("/");
      return;
    }

    if (!response.ok) {
      throw new Error(t("fetchPreferencesError"));
    }

    const data = await response.json();
    
    if (data.message && data.matching_profiles) {
      // if (data.message.includes("Utthamam")) {
      //   toast.info(data.message);
      // }
      setPreferenceProfiles(data.profiles?.length > 0 ? data.profiles : data.matching_profiles || []);
    } else {
      setPreferenceProfiles(data.profiles || []);
    }
    
    setLoading((prev) => ({ ...prev, preferences: false }));
  } catch (error) {
    setError(error.message);
    setPreferenceProfiles([]); // Fallback to empty array
    setLoading((prev) => ({ ...prev, preferences: false }));
  }
};

  const fetchPreferenceLocationProfiles = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/location-preference",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/");
        return;
      }

      if (!response.ok) {
        throw new Error(t("fetchLocationPreferencesError"));
      }

      const data = await response.json();
      // Normalize data to array
      setLocationPreferenceProfiles(data.profiles || []);
      setLoading((prev) => ({ ...prev, locationpreference: false }));
    } catch (error) {
      setError(error.message);
      setLocationPreferenceProfiles([]); // Fallback to empty array
      setLoading((prev) => ({ ...prev, locationpreference: false }));
    }
  };

  const fetchFavoriteProfiles = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        "https://backend.newbrindha.com/matrimony/get-favorite-profiles",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 401) {
        localStorage.removeItem("authToken");
        navigate("/");
        return;
      }

      if (!response.ok) {
        throw new Error(t("fetchFavoritesError"));
      }

      const data = await response.json();
      // Normalize data to array
      const favorites = Array.isArray(data)
        ? data
        : Array.isArray(data.favorites)
          ? data.favorites
          : Array.isArray(data.data)
            ? data.data
            : [];
      setFavoriteProfiles(favorites);
      setLoading((prev) => ({ ...prev, favorites: false }));
    } catch (error) {
      console.error("Error fetching favorites:", error);
      setFavoriteProfiles([]); // Fallback to empty array
      setLoading((prev) => ({ ...prev, favorites: false }));
      setError(error.message);
    }
  };

  useEffect(() => {
    fetchProfiles();
    fetchFavoriteProfiles();
    fetchPreferenceProfiles();
    fetchPreferenceLocationProfiles();
  }, [i18n.language]);

  const scrollLeft = (ref) => {
    ref.current.scrollBy({ left: -300, behavior: "smooth" });
    ref.current.animate({ x: "-=300" }, { duration: 500, ease: "easeInOut" });
  };

  const scrollRight = (ref) => {
    ref.current.scrollBy({ left: 300, behavior: "smooth" });
    ref.current.animate({ x: "+=300" }, { duration: 500, ease: "easeInOut" });
  };

  const ProfileCardImageShadow = {
    boxShadow: "rgba(5, 5, 5, 0.95) 0px -50px 36px -28px inset",
  };

  const ProfileCard = ({ profile, index, isNew = false }) => {
    const [showMobileDetails, setShowMobileDetails] = useState(false);
    const photo =
      profile.photo ||
      "https://images.unsplash.com/photo-1541823709867-1b206113eafd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTMxfHxnaXJsfGVufDB8fDB8fHww";

    const verificationStatus = profile.verification_status || "pending";
    const verificationColor = verificationStatus === "approve" ? "bg-green-500" : "bg-red-500";
    const verificationText = verificationStatus === "approve" ? t("approved") : t("pending");
    
    return (
      <motion.div
        key={index}
        className="no-scrollbar relative rounded-2xl cursor-pointer w-[160px] h-[240px] xs:w-[180px] xs:h-[260px] sm:w-[200px] sm:h-[280px] md:w-[220px] md:h-[300px] overflow-hidden group flex-shrink-0"
        onClick={() => {
          if (window.innerWidth < 640) {
            setShowMobileDetails(!showMobileDetails);
          }
        }}
      >

      {profile.nakshatra_match_type && (
       <div
        className={`absolute z-30 ${
          profile.nakshatra_match_type === 'Utthamam' ? 'bg-green-800' : 'bg-blue-500'
        } text-white text-[10px] xs:text-xs px-1.5 py-0.5 xs:px-2 xs:py-1 rounded-full font-medium shadow-lg left-2 top-52`}
      >
        
        {t("compatible")}
      </div>
      )}

    
        {/* Verification Badge */}
        <div
          className={`absolute z-30 ${verificationColor} text-white text-[10px] xs:text-xs px-1.5 py-0.5 
            xs:px-2 xs:py-1 rounded-full font-medium shadow-lg
            ${window.innerWidth < 640 ? 'top-2 left-2' : 'top-2 right-2'}
          `}
        >
          {verificationText}
        </div>

        {/* Viewed Badge */}
        {viewedProfiles.includes(profile.matrimony_id) && (
          <div
            className={`absolute z-30 bg-blue-500 text-white text-[10px] xs:text-xs 
              px-1.5 py-0.5 xs:px-2 xs:py-1 rounded-full font-medium shadow-lg
              ${window.innerWidth < 640 ? 'left-2 top-8' : 'left-2 top-2'}
            `}
          >
            {t("viewed")}
          </div>
        )}




        {/* Favorite button - always visible on mobile */}
        {/* <div
          className={`absolute top-2 right-2 z-20 ${
            window.innerWidth >= 640 ? 'hidden' : ''
          }`}
          onClick={(e) => {
            e.stopPropagation();
            toggleFavourite(profile);
          }}
        >
          {favorites.includes(profile.matrimony_id) ? (
            <HeartSolid className="h-5 w-5 text-red-500 border border-black rounded-full p-0.5 bg-white" />
          ) : (
            <HeartOutline className="h-5 w-5 text-white border border-black rounded-full p-0.5 bg-white" />
          )}
        </div> */}

         <div 
          className="absolute top-2 right-2 z-20 sm:hidden"
          onClick={(e) => {
            e.stopPropagation();
            toggleFavourite(profile);
          }}
        >
          {favorites.includes(profile.matrimony_id) ? (
            <HeartSolid className="h-5 w-5 text-red-500" />
          ) : (
            <HeartOutline className="h-5 w-5 text-white" />
          )}
        </div>

        {/* Rest of the component remains the same */}
        {(showMobileDetails || window.innerWidth >= 640) && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={window.innerWidth >= 640 ? { opacity: 0, y: 20 } : { opacity: 1, y: 0 }}
            whileHover={window.innerWidth >= 640 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className={`${window.innerWidth >= 640 ? 'hidden group-hover:flex' : 'flex'} flex-col absolute inset-0 bg-black/70 z-30 items-start justify-start text-white p-3 h-full w-full overflow-y-auto`}
          >
            <div
              className="hidden sm:block absolute top-3 right-3 cursor-pointer z-10"
              onClick={(e) => {
                e.stopPropagation();
                toggleFavourite(profile);
              }}
            >
              {favorites.includes(profile.matrimony_id) ? (
                <HeartSolid className="h-6 w-6 text-red-500" />
              ) : (
                <HeartOutline className="h-6 w-6 text-white" />
              )}
            </div>

            <p className="text-left text-sm xs:text-base sm:text-lg font-bold mb-1 sm:mb-2">
              {profile.full_name}
            </p>
            <div className="flex flex-col items-start justify-start space-y-0.5 sm:space-y-1 text-xs xs:text-sm w-full break-words">
              <p className="m-0">
                {t("age")}: {profile.age}
              </p>
              <p className="m-0">
                {t("location")}: {profile.work_location}
              </p>
              <p className="m-0">
                {t("occupation")}: {profile.occupation}
              </p>
              <button className="flex items-center gap-1 sm:gap-2 mt-1 sm:mt-2 text-white font-medium">
                <img
                  src={NavPointsIcon}
                  alt="points-icon"
                  className="w-4 h-4 sm:w-5 sm:h-5"
                />
                {"500"}
              </button>
            </div>

           <button
              onClick={() => handleSpendPoints(profile)}
              className="bg-[#fa6938] hover:bg-[#ff7142] active:bg-[#fa6938] mt-2 sm:mt-3 px-2 py-1 sm:px-3 sm:py-2 rounded-lg w-full text-xs sm:text-sm font-medium"
            >
              {viewedProfiles.includes(profile.matrimony_id) ? t("viewDetails") : t("moreDetails")}
            </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              openReportModal(profile.matrimony_id);
            }}
            className="mt-2 px-2 py-1 sm:px-3 sm:py-2 rounded-lg w-full text-xs sm:text-sm font-medium border border-white text-white hover:bg-black hover:text-white transition-colors duration-200"
          >
            {t("report")}
          </button>
          </motion.div>
        )}

        <div
          className="absolute w-full h-full z-10"
          style={ProfileCardImageShadow}
        />
        <img
          src={photo}
          alt={profile.full_name}
          className="w-full h-full object-cover z-30 transition-all duration-300 ease-in-out group-hover:scale-105"
        />
        <div className="absolute m-2 bottom-0 left-0 right-0 bg-white/50 px-2 py-1 sm:px-3 sm:py-2 rounded-2xl text-black flex items-center justify-between z-40">
          <div>
            <h3 className="font-bold text-xs xs:text-sm sm:text-[16px] leading-tight">
              {profile.full_name}
            </h3>
            <p className="text-xs mb-1 text-semibold">
              {t("age")}: {profile.age}
            </p>
          </div>
          <div className="text-white">
            <img
              src={RightArrowCard}
              alt="RightArrowCard"
              className="h-4 w-6 sm:h-6 sm:w-8"
            />
          </div>
        </div>
      </motion.div>
    );
  };


  const ProfileSection = ({
    title,
    profiles,
    loading,
    isNew = false,
    scrollContainerRef,
    scrollLeft,
    scrollRight,
  }) => {
    const { t } = useTranslation();

    if (loading) {
      return (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-600">{t("loadingProfiles")}</p>
        </div>
      );
    }

    // Ensure profiles is an array, fallback to empty array if not
    const safeProfiles = Array.isArray(profiles) ? profiles : [];

    if (!safeProfiles.length) {
      return (
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-600">{t("noProfilesFound")}</p>
        </div>
      );
    }

    const displayedProfiles = safeProfiles.slice(0, 6); // Limit to 6 profiles

    return (
      <div className="mb-8">
        <h2 className="text-xl font-bold mb-4 mt-5 text-[#676666]">
        {title}
        {profiles.some(p => p.nakshatra_match_type) && (
          <span className="text-lg font-semibold mb-2 text-[#676666] flex items-center gap-2">
            <FiSettings className="text-[#676666]" />
            {t("systemMatchedByNakshatra")}
          </span>
        )}
        </h2>

        <div className="relative">
          {safeProfiles.length > 2 && (
            <button
              onClick={scrollLeft}
              className=" absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-lg z-40"
            >
              <ChevronLeftIcon className="h-6 w-6 text-gray-700" />
            </button>
          )}
          <div
            ref={scrollContainerRef}
            className="flex gap-4 overflow-hidden px-2 sm:px-4"
            style={{ height: "300px" }}
          >
            {displayedProfiles.map((profile, index) => (
              <ProfileCard
                key={index}
                profile={profile}
                index={index}
                isNew={isNew}
                handleSpendPoints={handleSpendPoints}
                toggleFavourite={toggleFavourite}
                favorites={favorites}
                openReportModal={openReportModal}
              />
            ))}
            {safeProfiles.length > 6 && (
              <motion.div
                className="relative rounded-2xl cursor-pointer w-[160px] h-[240px] xs:w-[180px] xs:h-[260px] sm:w-[200px] sm:h-[280px] md:w-[220px] md:h-[300px] overflow-hidden flex-shrink-0 flex items-center justify-center"
                variants={{
                  hover: { scale: 1.05, transition: { duration: 0.2 } },
                  tap: { scale: 0.95 },
                }}
                whileHover="hover"
                whileTap="tap"
                onClick={() => openViewAllModal(safeProfiles, title)}
                style={{
                  background: "linear-gradient(135deg, #ff6b6b, #ff8e53)",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                }}
              >
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center z-30">
                  <p className="text-white font-bold text-lg sm:text-xl drop-shadow-lg">
                    {t("viewAll")}
                  </p>
                </div>
              </motion.div>
            )}
          </div>
          {safeProfiles.length > 2 && (
            <button
              onClick={scrollRight}
              className=" absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-lg z-40"
            >
              <ChevronRightIcon className="h-6 w-6 text-gray-700" />
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className=" flex bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient px-0 flex-col">
      <div className="min-h-[100dvh] w-full flex-grow">
        <Navbar />
        <main className="z-30 bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient p-4 md:p-6 space-y-10">
          {profiles.newProfiles?.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              {/* <p className="text-xl font-bold text-[#676666]">
                🌟 {t("newProfiles")}
              </p> */}
              <ProfileSection
                title={`🌟 ${t("newProfiles")}`}
                profiles={profiles.newProfiles}
                loading={loading.default}
                isNew={true}
                scrollContainerRef={newProfilesRef}
                scrollLeft={() => scrollLeft(newProfilesRef)}
                scrollRight={() => scrollRight(newProfilesRef)}
              />
            </motion.div>
          )}

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <p className="text-xl font-bold mb-4 text-[#676666]">
              🌀 {t("preferenceByRashi")}
            </p>
            <ProfileSection
              profiles={preferenceProfiles}
              loading={loading.preferences}
              scrollContainerRef={preferencesRef}
              scrollLeft={() => scrollLeft(preferencesRef)}
              scrollRight={() => scrollRight(preferencesRef)}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="text-xl font-bold mb-4 text-[#676666]">
              📍 {t("preferenceByLocation")}
            </p>
            <ProfileSection
              profiles={locationPreferenceProfiles}
              loading={loading.locationpreference}
              scrollContainerRef={locationRef}
              scrollLeft={() => scrollLeft(locationRef)}
              scrollRight={() => scrollRight(locationRef)}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <p className="text-xl font-bold mb-4 text-[#676666]">
              ❤️ {t("favorites")}
            </p>
            <ProfileSection
              profiles={favoriteProfiles}
              loading={loading.favorites}
              scrollContainerRef={favoritesRef}
              scrollLeft={() => scrollLeft(favoritesRef)}
              scrollRight={() => scrollRight(favoritesRef)}
            />
          </motion.div>

          {profiles.defaultProfiles?.length > 0 && (
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <p className="text-xl font-bold mb-4 text-[#676666]">
                ✨ {t("defaultProfiles")}
              </p>
              <ProfileSection
                title={`✨ ${t("defaultProfiles")}`}
                profiles={profiles.defaultProfiles}
                loading={loading.default}
              />
            </motion.div>
          )}
        </main>
      </div>
      <AnimatePresence>
        {selectedProfile && (
          <motion.div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
          >
            <motion.div
              className="bg-white rounded-xl max-w-4xl w-full p-4 overflow-y-auto max-h-[90vh] shadow-2xl"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-[18px] font-semibold text-[#676666]">
                  {t("profileDetails.profileDetails")}
                </h2>
                <button
                  onClick={() => setSelectedProfile(null)}
                  className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                >
                  <XMarkIcon className="h-6 w-6 font-semibold text-red-500" />
                </button>
              </div>
              <div
                className="absolute top-4 right-4 sm:hidden z-20"
                onClick={() => toggleFavourite(selectedProfile)}
              >
                {favorites.includes(selectedProfile.matrimony_id) ? (
                  <HeartSolid className="h-6 w-6 text-red-500" />
                ) : (
                  <HeartOutline className="h-6 w-6 text-gray-500" />
                )}
              </div>
              <div className="mb-6">
                <Carousel
                  interval={3000}
                  className="w-full h-96 rounded-lg overflow-hidden shadow-lg"
                  indicators={(selectedProfile.photos?.length || 0) > 0}
                  prevIcon={<ChevronLeftIcon className="h-8 w-8 text-black" />}
                  nextIcon={<ChevronRightIcon className="h-8 w-8 text-black" />}
                >
                  {selectedProfile.photo && (
                    <Carousel.Item>
                      <div className="relative w-full h-96 flex items-center justify-center bg-gray-100">
                        <img
                          src={selectedProfile.photo}
                          alt="Profile"
                          className="w-full h-full object-contain"
                          onError={(e) => {
                            e.target.src = "/default-placeholder.png";
                            console.error("Failed to load profile photo");
                          }}
                        />
                      </div>
                    </Carousel.Item>
                  )}
                  {selectedProfile.photos?.map((photo, index) => (
                    <Carousel.Item key={index}>
                      <div className="relative w-full h-96 flex items-center justify-center bg-gray-100">
                        <img
                          src={photo}
                          alt={`Photo ${index + 1}`}
                          className="w-full h-full object-contain"
                          onError={(e) => {
                            e.target.src = "/default-placeholder.png";
                            console.error(`Failed to load photo ${index + 1}`);
                          }}
                        />
                      </div>
                    </Carousel.Item>
                  ))}
                  {!selectedProfile.photo &&
                    !selectedProfile.photos?.length && (
                      <Carousel.Item>
                        <div className="relative w-full h-96 flex items-center justify-center bg-gray-100">
                          <img
                            src="/default-placeholder.png"
                            alt="Placeholder"
                            className="w-full h-full object-contain"
                          />
                        </div>
                      </Carousel.Item>
                    )}
                </Carousel>
              </div>
              <div className="space-y-4">
                <Section
                  title={t("personalDetails")}
                  isOpen={openSections.personal}
                  toggle={() => toggleSection("personal")}
                >
                  <DetailItem
                    label={t("name")}
                    value={selectedProfile.full_name}
                  />
                  <DetailItem
                    label={t("matrimonyId")}
                    value={selectedProfile.matrimony_id}
                  />
                  <DetailItem label={t("age")} value={selectedProfile.age} />
                  <DetailItem
                    label={t("gender")}
                    value={selectedProfile.gender}
                  />
                  <DetailItem
                    label={t("dateOfBirth")}
                    value={selectedProfile.date_of_birth}
                  />
                  <DetailItem
                    label={t("height")}
                    value={selectedProfile.height}
                  />
                  <DetailItem
                    label={t("weight")}
                    value={selectedProfile.weight}
                  />
                  <DetailItem
                    label={t("email")}
                    value={selectedProfile.email}
                  />
                  <DetailItem
                    label={t("phone")}
                    value={selectedProfile.phone_number}
                  />
                  <DetailItem
                    label={t("motherTongue")}
                    value={selectedProfile.mother_tongue}
                  />
                  <DetailItem
                    label={t("native")}
                    value={selectedProfile.native}
                  />
                  <DetailItem
                    label={t("religion")}
                    value={selectedProfile.religion}
                  />
                  <DetailItem
                    label={t("caste")}
                    value={selectedProfile.caste}
                  />
                  <DetailItem
                    label={t("subCaste")}
                    value={selectedProfile.sub_caste}
                  />
                  <DetailItem
                    label={t("bloodGroup")}
                    value={selectedProfile.blood_group}
                  />
                </Section>
                <Section
                  title={t("familyProfessionalDetails")}
                  isOpen={openSections.family}
                  toggle={() => toggleSection("family")}
                >
                  <DetailItem
                    label={t("fatherName")}
                    value={selectedProfile.father_name}
                  />
                  <DetailItem
                    label={t("motherName")}
                    value={selectedProfile.mother_name}
                  />
                  <DetailItem
                    label={t("fatherOccupation")}
                    value={selectedProfile.father_occupation}
                  />
                  <DetailItem
                    label={t("motherOccupation")}
                    value={selectedProfile.mother_occupation}
                  />
                  <DetailItem
                    label={t("siblingCount")}
                    value={selectedProfile.sibling_count}
                  />
                  <DetailItem
                    label={t("occupation")}
                    value={selectedProfile.occupation}
                  />
                  <DetailItem
                    label={t("annualIncome")}
                    value={selectedProfile.annual_income}
                  />
                  <DetailItem
                    label={t("education")}
                    value={selectedProfile.education}
                  />
                  <DetailItem
                    label={t("company")}
                    value={selectedProfile.company}
                  />
                  <DetailItem
                    label={t("workLocation")}
                    value={selectedProfile.work_location}
                  />
                  <DetailItem
                    label={t("workCountry")}
                    value={selectedProfile.work_country}
                  />
                </Section>
                <Section
                  title={t("horoscopeDetails")}
                  isOpen={openSections.horoscope}
                  toggle={() => toggleSection("horoscope")}
                >
                  <DetailItem
                    label={t("nakshatra")}
                    value={selectedProfile.nakshatra}
                  />
                  <DetailItem
                    label={t("rashi")}
                    value={selectedProfile.rashi}
                  />
                  <DetailItem
                    label={t("ascendent")}
                    value={selectedProfile.ascendent}
                  />
                  <DetailItem
                    label={t("birthTime")}
                    value={selectedProfile.birth_time}
                  />
                  <DetailItem
                    label={t("birthPlace")}
                    value={selectedProfile.birth_place}
                  />
                </Section>
                <Section
                  title={t("preferences")}
                  isOpen={openSections.preferences}
                  toggle={() => toggleSection("preferences")}
                >
                  <DetailItem
                    label={t("preferredAgeRange")}
                    value={
                      selectedProfile.preferred_age_min &&
                      selectedProfile.preferred_age_max
                        ? `${selectedProfile.preferred_age_min} - ${selectedProfile.preferred_age_max}`
                        : t("notSpecified")
                    }
                  />
                  <DetailItem
                    label={t("preferredHeightRange")}
                    value={
                      selectedProfile.preferred_height_min &&
                      selectedProfile.preferred_height_max
                        ? `${selectedProfile.preferred_height_min} - ${selectedProfile.preferred_height_max}`
                        : t("notSpecified")
                    }
                  />
                  <DetailItem
                    label={t("preferredReligion")}
                    value={selectedProfile.preferred_religion}
                  />
                  <DetailItem
                    label={t("preferredCaste")}
                    value={selectedProfile.preferred_caste}
                  />
                  <DetailItem
                    label={t("preferredSubCaste")}
                    value={selectedProfile.preferred_sub_caste}
                  />
                  <DetailItem
                    label={t("preferredStatus")}
                    value={selectedProfile.preferred_work_status}
                  />
                  <DetailItem
                    label={t("preferredLocation")}
                    value={selectedProfile.preferred_location}
                  />
                </Section>
                <Section
                  title={t("documents")}
                  isOpen={openSections.documents}
                  toggle={() => toggleSection("documents")}
                >
                  {selectedProfile.horoscope_documents?.length > 0 ? (
                    selectedProfile.horoscope_documents.map(
                      (documentUrl, index) => (
                        <div key={`horoscope-${index}`} className="mt-4 mb-2">
                          <button
                            onClick={() => window.open(documentUrl, "_blank")}
                            className="flex items-center text-blue-500 hover:text-blue-700 transition-colors duration-200"
                          >
                            <DocumentIcon className="h-5 w-5 mr-2" />
                            <span>
                              {t("viewHoroscopeDocument", { index: index + 1 })}
                            </span>
                          </button>
                        </div>
                      ),
                    )
                  ) : (
                    <p>{t("noHoroscopeDocuments")}</p>
                  )}
                </Section>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {showConfirmPopup && (
          <motion.div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              className="bg-white rounded-xl max-w-md w-full p-6 shadow-2xl relative overflow-hidden"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
              <h3 className="text-lg font-semibold text-[#676666] mb-4">
                {t("confirmPointsSpend")}
              </h3>
              <p className="text-gray-600 mb-4">
                {t("spendPointsMessage", {
                  points: 100,
                  name: profileToView?.full_name,
                })}
              </p>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => setShowConfirmPopup(false)}
                  className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50"
                >
                  {t("noThanks")}
                </button>
                <button
                  onClick={confirmSpendPoints}
                  className="px-4 py-2 bg-[#fa6938] text-white rounded-md text-sm font-medium hover:bg-[#ff7142]"
                >
                  {t("confirm")}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {showReportModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]">
            <div className="bg-white rounded-xl max-w-md w-full p-6 shadow-2xl">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold">{t("reportProfile")}</h3>
                <button
                  onClick={() => {
                    setShowReportModal(false);
                    setReportReason("");
                  }}
                  className="p-1 rounded-lg hover:bg-gray-100"
                >
                  <XMarkIcon className="h-6 w-6 text-gray-500" />
                </button>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("reportReason")}
                </label>
                <textarea
                  value={reportReason}
                  onChange={(e) => setReportReason(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#FFA500]"
                  rows={4}
                  placeholder={t("reportReasonPlaceholder")}
                />
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => {
                    setShowReportModal(false);
                    setReportReason("");
                  }}
                  className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium hover:bg-gray-50"
                >
                  {t("cancel")}
                </button>
                <button
                  onClick={handleReportProfile}
                  className="px-4 py-2 bg-[#fa6938] text-white rounded-md text-sm font-medium hover:bg-[#ff7142]"
                >
                  {t("submitReport")}
                </button>
              </div>
            </div>
          </div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {ShowPopupRechargePoints && (
          <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[999]"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          >
            <div
              className="relative bg-white rounded-xl max-w-2xl w-full p-4 overflow-y-auto max-h-[90vh] shadow-2xl"
              initial={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
              animate={{ scale: 1, opacity: 1, rotateX: 0, rotateY: 0 }}
              exit={{ scale: 0.9, opacity: 0, rotateX: -15, rotateY: -15 }}
              transition={{ type: "spring", stiffness: 100, damping: 20 }}
            >
              <button
                onClick={() => setShowPopupRechargePoints(false)}
                className="p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              >
                <XMarkIcon className="absolute right-2 top-2 h-8 w-8 font-semibold text-red-500 hover:bg-gray-100 p-1 rounded-lg" />
              </button>
              <p>{t("insufficientPoints")}</p>
              <div className="flex justify-end">
                <button
                  onClick={() => navigate("/points")}
                  className="px-3 py-1.5 rounded-lg bg-[#fa6938] hover:bg-[#ff7142] active:bg-[#fa6938] mt-2 text-white font-medium"
                >
                  {t("goToRecharge")}
                </button>
              </div>
            </div>
          </div>
        )}
      </AnimatePresence>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Footer />
    </div>
  );
};

export default Dashboard;
